import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from '../../../services/validation.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'control-messages',
  template: `<div *ngIf="errorMessage !== null"
            class="form-control-feedback" >
            {{errorMessage}}
            </div>`,
  
  styles:[]
})
export class ControlMessagesComponent {
  @Input() control: FormControl;
  constructor() {

   }

  get errorMessage() {
    for (let propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    
    return null;
  }
}


// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/components/shared/control-messages/control-messages.component.ts